import { atom } from 'recoil';

const videoHState = atom({
  key: 'player/videoH',
  default: 100,
});

export { videoHState };
